export default "__VITE_PUBLIC_ASSET__eec1f643__"